import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
export function Layout() {
  const location = useLocation();
  return <MotionConfig reducedMotion="user" data-id="element-254" data-mp="304tptmfudbzs">
      <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-255" data-mp="305v2fvcia6jm">
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-sm focus:bg-gold focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-navy" data-id="element-256" data-mp="3546co76pqj2d">
          Skip to content
        </a>
        <ScrollToTop data-id="element-257" data-mp="3j2w7fg6286nk" />
        <Header data-id="element-258" data-mp="3j3foyvrsst12" />
        <main id="main" className="flex-1" data-id="element-259" data-mp="3j1uzvlo962al">
          {/* Keyed by route so the fade-and-rise replays on every page change */}
          <div key={location.pathname} className="av-page" data-id="element-260" data-mp="1kpmko725ifzu">
            <Outlet data-id="element-261" data-mp="1oq6htamq5jlz" />
          </div>
        </main>
        <Footer data-id="element-262" data-mp="3n0tl73wrn3s9" />
      </div>
    </MotionConfig>;
}